import type { SVGProps } from 'react';

import { unitMapping, type Unit } from '#src/lib/style.ts';

export const ArenaIcon = (props: SVGProps<SVGSVGElement> & { size?: Unit }) => {
  const { size = 3 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17 24"
      fill="none"
      style={{ height: unitMapping[size], width: 'auto' }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.35694 6.69336C3.60348 6.61087 6.48975 6.70508 6.48975 6.70508L8.28565 9.9248L10.1753 6.70312L13.4985 6.67676C13.5197 6.99957 13.3858 7.39521 13.6743 7.61914L13.6724 7.61719H16.6655C16.7031 9.97879 15.7005 12.1354 13.7681 13.4883C13.1517 13.9225 11.5888 14.6733 11.5591 14.6875L9.29542 17.4834L9.32569 19.5264L10.4439 22.2324H12.6157L12.9087 24H3.75147L3.98585 22.2324H6.21729L7.22217 19.5264L7.37256 17.3604C7.37256 17.3604 5.27357 14.7354 5.13233 14.6006C4.9868 14.4616 3.62549 13.9647 3.24464 13.7266C1.89466 12.8782 0.678489 11.3084 0.28858 9.74121C0.192311 9.35468 -0.0196613 8.23938 0.00147109 7.90234C0.00854458 7.79392 0.102917 7.61914 0.173346 7.61914H2.98878L3.35694 6.69336ZM1.34717 8.68262C1.10767 8.8476 1.3474 9.5032 1.43897 9.76953H1.43604C1.89631 11.1152 2.89487 12.2225 4.10401 12.9248C3.78233 11.5861 3.27923 10.2826 3.26514 8.87793L3.10792 8.68262H1.34717ZM13.5571 8.68066L13.3999 8.87598C13.4304 10.2948 12.8991 11.5842 12.561 12.9229C14.1317 12.0556 15.2916 10.507 15.4937 8.68066H13.5571Z"
        fill="white"
      />
      <path
        d="M9.54932 2.48633L12.0903 3.94727L9.3501 5.31445L8.3335 7.61035L7.27881 5.31445L4.57667 3.94727L7.0796 2.48633L8.3335 0L9.54932 2.48633Z"
        fill="white"
      />
    </svg>
  );
};
